import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { FuaAssessmentQuestionnaireItem } from './questionnaire'

export const FUA_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  // Assessment overview
  [FuaAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START]:
    QuestionnaireAnswerType.DATE_TIME,
  [FuaAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END]:
    QuestionnaireAnswerType.DATE_TIME,
  [FuaAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_REASON_FOR_DOCUMENTATION]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_IN_PERSON]: QuestionnaireAnswerType.BOOLEAN,
  [FuaAssessmentQuestionnaireItem.ASSESSMENT_EFFECTIVE_DATE]: QuestionnaireAnswerType.DATE_TIME,
  [FuaAssessmentQuestionnaireItem.ASSESSMENT_REVISABLE_CARE_PLAN]:
    QuestionnaireAnswerType.REFERENCE,

  // Cert Period Recap
  [FuaAssessmentQuestionnaireItem.CERT_PERIOD_RECAP_CONSENT]: QuestionnaireAnswerType.REFERENCE,

  // Authorizations
  [FuaAssessmentQuestionnaireItem.AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]:
    QuestionnaireAnswerType.REFERENCE,
  [FuaAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS]:
    QuestionnaireAnswerType.DECIMAL,
  [FuaAssessmentQuestionnaireItem.AUTHORIZATION_ACUTE_PERIOD_PERIOD_START]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.AUTHORIZATION_ACUTE_PERIOD_PERIOD_END]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.AUTHORIZATION_ACUTE_PERIOD_CURRENT_ACTIVE]:
    QuestionnaireAnswerType.REFERENCE,

  // Visit scheduling
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_WAKEUP_TIME]:
    QuestionnaireAnswerType.TIME,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_BEDTIME]:
    QuestionnaireAnswerType.TIME,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_DAY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_NAME]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_REPEATS_ON_DAY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VALID]:
    QuestionnaireAnswerType.BOOLEAN,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_WEEKDAY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_CHANGE_REASON]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_ADDITIONAL_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VISIT_SCHEDULING_INITIALS_AUTHORIZATION]:
    QuestionnaireAnswerType.STRING,

  // Medical background
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_PRIMARY_DIAGNOSIS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_OTHER_DIAGNOSIS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_EQUIPMENT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_DME_PROVIDER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ALLERGIES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ALLERGIES_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_WAIVERS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ADDITIONAL_SERVICES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_PROGNOSIS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_DNR]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ADVANCE_DIRECTIVES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ADVANCE_DIRECTIVES_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B_HEP_B]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL_MENINGOCOCCAL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19_COVID_19]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP_DTAP]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV_HPV]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV_RSV]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_NOTES]:
    QuestionnaireAnswerType.STRING,

  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_HOSPITALIZATION_RISK]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_HOSPITALIZATION_RISK_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_TRIAGE_CODE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_EMERGENCY_PLAN]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_SAFE_ROOM]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FIRE_ASSESSMENT_OXYGEN]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FIRE_SAFETY_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_HOMEBOUND_STATUS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_INFECTION_RISK]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_INFECTION_RISK_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FALL_RISK]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FALL_RISK_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FALL_RISK_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FINANCE_RISK]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_ENVIRONMENT_SAFETY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_NURSE_SAFETY_RISKS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_SAFETY_MEASURES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_HEADACHES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_HEADACHE_TYPE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SEIZURES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SEIZURE_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SEIZURE_TYPE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SEIZURE_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_NEURO_STATUS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_ALTERED_AFFECT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_ALTERED_AFFECT_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_PHQ2_SCREENING]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_PHQ2_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_INTEREST]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_DEPRESSED]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_CAREGIVER_DIFFICULTY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_NEURO_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_COMMUNICATION_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_COGNITIVE_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_HISTORY_SUBSTANCE_ABUSE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_SUBSTANCE_ABUSE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_LINES_DRAINS_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_THERAPIES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_THERAPY_PROVIDER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_PLAN]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_DURATION]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_FREQUENCY]:
    QuestionnaireAnswerType.INTEGER,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EYES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EARS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_NOSE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TOUCH]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TASTE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_STATUS]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_GOAL]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_FACE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_LEGS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_ACTIVITY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_CRY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_CONSOLABILITY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_RESPIRATORY_WNL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_COUGH]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_OXYGEN]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_LUNG_SOUNDS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RESPIRATORY_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_ENDOCRINE_WNL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_MENSTRUAL_CYCLE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_MENSTRUAL_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_ENDOCRINE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_ENDOCRINE_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_GI_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_BM_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_GU_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_CATHETER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_CATHETER_TYPE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_AMOUNT]:
    QuestionnaireAnswerType.INTEGER,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TOTAL_NUMBER]:
    QuestionnaireAnswerType.INTEGER,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_DURATION]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_TYPE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_SITE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_SIZE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_FEEDING_TUBE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_NUTRITION_WNL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_NUTRITIONAL_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_DIET_REQUIREMENTS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_NUTRITION_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_NUTRITIONAL_SCREENING]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_GASTROINTESTINAL_HISTORY_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_GASTROINTESTINAL_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_SKIN_COLOR]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_SKIN_ISSUES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_NAILS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_IDENTIFIED_WOUNDS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_WOUND_NOTES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_INTEGUMENTARY_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_TEMP_GREATER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_TEMP_LESS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_PULSE_GREATER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_PULSE_LESS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_RESPIRATIONS_GREATER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_RESPIRATIONS_LESS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_BP_GREATER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_BP_LESS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_WEIGHT_GREATER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_WEIGHT_LESS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_ETCO2_SATURATION_GREATER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_ETCO2_SATURATION_LESS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_O2_SATURATION_GREATER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_PHYSICIAN_NOTIFICATION_O2_SATURATION_LESS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_PREVIOUS_APPOINTMENTS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_FUTURE_APPOINTMENTS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_CARE_TEAM_COORDINATION]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_ORDERS_FOR_TREATMENT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_INITIALS_AUTHORIZATION]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION]:
    QuestionnaireAnswerType.DATE_TIME,

  // Medications
  [FuaAssessmentQuestionnaireItem.MEDICATIONS]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DRUGBANK_PCID]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_NAME]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_ROUTE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_STRENGTH_NUMBER]:
    QuestionnaireAnswerType.DECIMAL,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_STRENGTH_UNIT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INDICATIONS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_FREQUENCY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DOSAGE_NUMBER]:
    QuestionnaireAnswerType.DECIMAL,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DOSAGE_UNIT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INSTRUCTIONS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_USAGE_STATUS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_START_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DISCONTINUE_DATE]:
    QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_CONTROLLED]:
    QuestionnaireAnswerType.BOOLEAN,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_LIQUID]:
    QuestionnaireAnswerType.BOOLEAN,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INFECTION]:
    QuestionnaireAnswerType.BOOLEAN,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_SUMMARY]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.MEDICATIONS_INITIALS_AUTHORIZATION]:
    QuestionnaireAnswerType.STRING,

  // Skilled Needs
  [FuaAssessmentQuestionnaireItem.SKILLED_NEEDS]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_NAME]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_SCORE]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_NOTE]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_PREVIOUS_NOTE]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SKILLED_NEED_INITIALS_AUTHORIZATION]:
    QuestionnaireAnswerType.STRING,

  // ADL Needs
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED_ID]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED_OBSERVATION_REFERENCE]:
    QuestionnaireAnswerType.REFERENCE,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED_NAME]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED_NEW_NOTE]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED_IS_ARCHIVED]: QuestionnaireAnswerType.BOOLEAN,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_AUTHOR]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_DATE]: QuestionnaireAnswerType.DATE,
  [FuaAssessmentQuestionnaireItem.ADL_NEEDS_NEED_LAST_NOTE_TEXT]: QuestionnaireAnswerType.STRING,

  // Discharge Planning
  [FuaAssessmentQuestionnaireItem.DISCHARGE_PLANNING]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.DISCHARGE_PLANNING_NOTES]: QuestionnaireAnswerType.STRING,

  // Plan of Care
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_GOALS]: QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_GOALS_GOAL]: QuestionnaireAnswerType.INTEGER,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO]:
    QuestionnaireAnswerType.GROUP,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INTERVENTION]:
    QuestionnaireAnswerType.INTEGER,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_CATEGORY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_GOAL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TASK]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INDICATION]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TYPE]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INSTRUCTION]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_PATIENT_CENTERED_GOAL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_ADDITIONAL_DETAILS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_VISITS]:
    QuestionnaireAnswerType.INTEGER,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_FREQUENCY]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.PLAN_OF_CARE_INITIALS_AUTHORIZATION]:
    QuestionnaireAnswerType.STRING,

  // Supervisory Review
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_ID_BADGE]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_HONORING_RIGHTS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_REPORTING_CHANGES]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_PPE_ACCESS]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_SUPERVISION_OBSERVED]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_TASK_OBSERVED]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_PATIENT_STATUS]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_COMMENTS]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION_CAREGIVER_EDUCATION_TOPIC]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION_EDUCATION_PROVIDED]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.SUPERVISORY_REVIEW_INITIALS_AUTHORIZATION]:
    QuestionnaireAnswerType.STRING,

  // Vitals
  [FuaAssessmentQuestionnaireItem.VITALS_BLOOD_PRESSURE]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VITALS_BLOOD_SUGAR]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VITALS_TEMPERATURE]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VITALS_HEIGHT]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VITALS_WEIGHT]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VITALS_O2_SATURATION]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VITALS_RESPIRATIONS]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VITALS_PULSE]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.VITALS_INITIALS_AUTHORIZATION]: QuestionnaireAnswerType.STRING,

  // Narrative background

  [FuaAssessmentQuestionnaireItem.NARRATIVE_BACKGROUND]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_SYSTEM_SUMMARIES]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_OVERVIEW]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_SKILLED_NEEDS]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_ADL_NEEDS]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_PATIENT_SERVICES]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_CARE_COORDINATION]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_PATIENT_GOALS]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_EDUCATION]: QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.NARRATIVE_FINAL_NOTES]: QuestionnaireAnswerType.STRING,

  // Final Steps
  [FuaAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION]:
    QuestionnaireAnswerType.STRING,
  [FuaAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES]: QuestionnaireAnswerType.STRING
}
